import React, { useState, useCallback } from "react";
import { toastr } from "react-redux-toastr";
import { useDropzone } from "react-dropzone";
import { S3ClientForUserApplications } from "../../../utils/s3Config";

function DoctorMinistryEssay(props) {
  const { removeFile, updateForm, doctorMinistryEssay, isDoctorEssayImage } = props;

  const [state, setState] = useState({
    dmEssayLoader: false,
  });

  const onDrop = useCallback((acceptedFiles) => {
    setState({ ...state, dmEssayLoader: true });
    if (acceptedFiles && acceptedFiles.length > 0) {
      let file = acceptedFiles[0];
      if (file.length === 0) {
        toastr.error("Error", "Please upload correct file");
        return;
      }
      if (file.size > 5000000) {
        toastr.error("Error", "Please upload file less than 5MB");
        return;
      }

      S3ClientForUserApplications.uploadFile(file, new Date().getTime())
        .then((data) => {
          updateForm(
            "doctorMinistryEssay",
            data && data.location ? data.location : null
          );
          state.isDoctorEssayImage =
            file.type == "image/jpeg" || file.type == "image/png";
          setState({ ...state, dmEssayLoader: false });
        })
        .catch((err) => {
          toastr.error("Error", "Doctor of Ministry Essay Uploading Fail");
          setState({ ...state, dmEssayLoader: false });
        });
    } else {
      setState({ ...state, dmEssayLoader: false });
      toastr.error("Error", "Invalid File Type. PDF only");
    }
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: ".pdf",
  });

  return (
    <>
      <div className='sub-heading app-info'>
        Doctor of Ministry Essay (Required)
      </div>
      <div className='field-label'>
        Please submit an essay of up to six (6)pages in length addressing the
        following:
        <ol placeholder='Select'>
          <li>
            How do you understand public ministry and what has been your
            experience in such spaces?
          </li>
          <li>
            Why are you applying to this DMin program at Bayan and how will it
            assist you in your ministerial identity and vocation?
          </li>
          <li>
            Your academic and/or professional objectives and what skills you
            hope to learn in this program;
          </li>
          <li>
            A detailed description of your research interests, including
            previous work in this area and the directions you might pursue;
          </li>
          <li>
            How Bayan commitments and areas of study appeal to your research and
            interests;
          </li>
          <li>
            The particular resources, academic scholarship, and faculty at Bayan
            and CTS that you plan to use and that have led you to make this
            application for admission.
          </li>
        </ol>
      </div>
      {state.dmEssayLoader && (
        <img
          src={`/icons/loading.svg`}
          style={{
            height: "25px",
            marginLeft: "10px",
            backgroundColor: "#000",
          }}
        />
      )}
      <div className='input-group'>
        <div className='drag-block'>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            {isDragActive ? (
              <p>Drag & Drop a File or Click to Choose</p>
            ) : (
              <p>Drag & Drop a File or Click to Choose</p>
            )}
          </div>
        </div>
        {doctorMinistryEssay && (
          <ul className='multi-images'>
            <li>
              <span>
                {isDoctorEssayImage ? (
                  <img
                    src={doctorMinistryEssay}
                    alt='Doctor of Ministry Essay'
                  />
                ) : (
                  <img className='doc-icon' src='/icons/file-icon.svg' />
                )}
                <div className='thumb_overlay'>
                  <div
                    className='thumb_cross'
                    onClick={() => removeFile("doctorMinistryEssay")}
                  >
                    ✕
                  </div>
                </div>
              </span>
            </li>
          </ul>
        )}
      </div>
      {doctorMinistryEssay === false && (
        <div className='field-error'>Must add Doctor of Ministry Essay</div>
      )}
    </>
  );
}

export default DoctorMinistryEssay;
